function initLikhaanInteractions() {
    const PROXY_URL = '/apps/social';
    const CUSTOMER_ID = window['LikhaanCustomerId'];

    // --- Open Modal from URL on Load ---
    if (window.URLSearchParams) {
        const urlParams = new URLSearchParams(window.location.search);
        const postParam = urlParams.get('post');
        if (postParam) {
            const modal = document.getElementById(`LikhaanModal-${postParam}`);
            if (modal) {
                modal.classList.add('active');
                document.body.style.overflow = 'hidden';
            }
        }
    }

    // --- Modal Logic using Event Delegation ---
    document.body.addEventListener('click', (e) => {
        const target = /** @type {Element} */ (e.target);
        if (!target || !target.closest) return;

        // 1. Open Modal
        const card = target.closest('.likhaan-post-card');
        if (card && !target.closest('button, a, .likhaan-post-interactions')) {
            const postId = card.getAttribute('data-post-id');
            console.log('Clicked post card. Post ID:', postId);
            
            const modalId = `LikhaanModal-${postId}`;
            const modal = document.getElementById(modalId);
            console.log('Looking for modal with ID:', modalId, 'Found:', modal ? 'Yes' : 'No');
            
            if (modal) {
                modal.classList.add('active');
                document.body.style.overflow = 'hidden';
                if (window.history && window.history.pushState) {
                    window.history.pushState(null, '', '?post=' + postId);
                }
            } else {
                console.error('Modal not found in DOM!');
            }
            return;
        }

        // 2. Close Modal via Close Button
        const closeBtn = target.closest('.likhaan-modal-close');
        if (closeBtn) {
            const modal = closeBtn.closest('.likhaan-modal-overlay');
            if (modal) {
                modal.classList.remove('active');
                document.body.style.overflow = '';
                if (window.history && window.history.pushState) {
                    window.history.pushState(null, '', window.location.pathname);
                }
            }
            return;
        }

        // 3. Close Modal via Overlay Click
        if (target.classList.contains('likhaan-modal-overlay')) {
            target.classList.remove('active');
            document.body.style.overflow = '';
            if (window.history && window.history.pushState) {
                window.history.pushState(null, '', window.location.pathname);
            }
            return;
        }

        // 4. Toggle Save Dropdown
        const saveBtn = target.closest('.likhaan-save-btn');
        if (saveBtn) {
            const dropdown = saveBtn.nextElementSibling;
            if (dropdown && dropdown.classList.contains('likhaan-save-dropdown')) {
                const isActive = dropdown.classList.contains('active');
                // Close all other dropdowns
                document.querySelectorAll('.likhaan-save-dropdown.active').forEach(d => d.classList.remove('active'));
                
                if (!isActive) {
                    dropdown.classList.add('active');
                }
            }
            return;
        }

        // 5. Close Save Dropdowns if clicked outside
        if (!target.closest('.likhaan-save-dropdown')) {
            document.querySelectorAll('.likhaan-save-dropdown.active').forEach(dropdown => {
                dropdown.classList.remove('active');
            });
        }

        // 6. Open Create Collection Modal
        const openCreateBtn = target.closest('.likhaan-open-new-collection-btn');
        if (openCreateBtn) {
            const modalId = openCreateBtn.getAttribute('data-modal');
            if (modalId) {
                const createModal = document.getElementById(modalId);
                if (createModal) {
                    // close the save dropdown first
                    document.querySelectorAll('.likhaan-save-dropdown.active').forEach(d => d.classList.remove('active'));
                    createModal.classList.add('active');
                }
            }
            return;
        }

        // 7. Close Create Collection Modal via Overlay Click
        if (target.classList.contains('likhaan-create-collection-modal-overlay')) {
            target.classList.remove('active');
            return;
        }

        // 8. Open Report Modal
        const openReportBtn = target.closest('.likhaan-report-btn');
        if (openReportBtn) {
            const modalId = openReportBtn.getAttribute('data-modal');
            const postId = modalId ? modalId.replace('ReportModal-', '') : null;

            if (!CUSTOMER_ID) {
                if (postId) showToast(postId, "Please log in to report a post.");
                else alert("Please log in to report a post.");
                return;
            }
            
            if (postId) {
                const storageKey = `likhaan_reported_posts_${CUSTOMER_ID}`;
                const reportedPosts = JSON.parse(localStorage.getItem(storageKey) || '[]');
                if (reportedPosts.includes(postId)) {
                    showToast(postId, "You have already reported this post. Our admins are reviewing it.");
                    return;
                }
            }
            
            if (modalId) {
                const reportModal = document.getElementById(modalId);
                if (reportModal) {
                    reportModal.classList.add('active');
                }
            }
            return;
        }

        // 9. Close Report Modal via Overlay Click
        if (target.classList.contains('likhaan-report-modal-overlay')) {
            target.classList.remove('active');
            return;
        }
    });

    // --- Carousel Logic ---
    const carousels = document.querySelectorAll('.likhaan-media-carousel');
    carousels.forEach(carousel => {
        const slides = carousel.querySelectorAll('.likhaan-carousel-slide');
        const prevBtn = carousel.querySelector('.likhaan-carousel-prev');
        const nextBtn = carousel.querySelector('.likhaan-carousel-next');
        let currentIndex = 0;

        if (!prevBtn || !nextBtn || slides.length <= 1) return;

        const showSlide = (index) => {
            slides.forEach(s => s.classList.remove('active'));
            slides[index].classList.add('active');
        };

        prevBtn.addEventListener('click', () => {
            currentIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
            showSlide(currentIndex);
        });

        nextBtn.addEventListener('click', () => {
            currentIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
            showSlide(currentIndex);
        });
    });

    // --- Share Logic ---
    const shareBtns = document.querySelectorAll('.likhaan-share-btn');
    shareBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const url = btn.getAttribute('data-url');
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: 'Likhaan Post',
                        url: url
                    });
                } catch (err) {
                    console.log('Error sharing:', err);
                }
            } else {
                navigator.clipboard.writeText(url).then(() => {
                    alert('Link copied to clipboard!');
                });
            }
        });
    });

    // --- Helper function for API ---
    async function apiRequest(action, data) {
        if (!CUSTOMER_ID) {
            alert("Please log in to perform this action.");
            return null;
        }
        
        try {
            const response = await fetch(PROXY_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: action,
                    customerId: CUSTOMER_ID,
                    ...data
                })
            });
            
            const textRaw = await response.text();
            let json;
            try {
                json = JSON.parse(textRaw);
            } catch (e) {
                console.error(`Received non-JSON response (${response.status}):\n`, textRaw);
                alert(`Server responded with an error (${response.status}):\n${textRaw.substring(0, 100)}`);
                return null;
            }
            
            if (!response.ok) {
                console.error("API Error:", json);
            }
            return json;
        } catch (error) {
            console.error(`Network/Fetch error in ${action}:`, error);
            alert(`A network error occurred: ${error.message}`);
            return null;
        }
    }

    // --- Like Logic ---
    const likeBtns = document.querySelectorAll('.likhaan-like-btn');
    
    // Initial fetch for liked statuses
    if (CUSTOMER_ID && likeBtns.length > 0) {
        const postIds = Array.from(likeBtns).map(btn => btn.getAttribute('data-id')).filter(Boolean);
        fetch('/apps/social', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'check_liked_statuses', customerId: CUSTOMER_ID, postIds })
        })
        .then(res => res.json())
        .then(result => {
            if (result && result.likedPosts) {
                likeBtns.forEach(btn => {
                    const pid = btn.getAttribute('data-id');
                    const isLiked = result.likedPosts.some(likedId => likedId === pid || likedId.endsWith(pid));
                    if (isLiked) {
                        btn.classList.add('liked');
                    }
                });
            }
        })
        .catch(err => console.log('Live liked statuses fetch failed.', err));
    }

    likeBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const postId = btn.getAttribute('data-id');
            const countSpan = btn.querySelector('.likhaan-likes-count');
            
            // Optimistic UI updates
            const isLiked = btn.classList.contains('liked');
            let currentCount = parseInt(countSpan ? countSpan.textContent || '0' : '0') || 0;
            
            if (isLiked) {
                btn.classList.remove('liked');
                if (countSpan) countSpan.textContent = String(Math.max(0, currentCount - 1));
            } else {
                btn.classList.add('liked');
                if (countSpan) countSpan.textContent = String(currentCount + 1);
            }

            const result = await apiRequest('like_post', { postId });
            if (result && result.success !== undefined) {
                // Confirm server state
                if (result.isLiked) {
                    btn.classList.add('liked');
                } else {
                    btn.classList.remove('liked');
                }
                if (countSpan) countSpan.textContent = String(result.likesCount);
            } else {
                // Revert if error
                if (isLiked) {
                    btn.classList.add('liked');
                    if (countSpan) countSpan.textContent = String(currentCount);
                } else {
                    btn.classList.remove('liked');
                    if (countSpan) countSpan.textContent = String(currentCount);
                }
            }
        });
    });

    // --- Comment Logic ---
    const commentSubmitBtns = document.querySelectorAll('.likhaan-comment-submit-btn');
    commentSubmitBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const postId = btn.getAttribute('data-post-id');
            const input = /** @type {HTMLTextAreaElement|null} */ (document.getElementById(`CommentInput-${postId}`));
            if (!input) return;
            const content = input.value.trim();
            const list = document.getElementById(`CommentsList-${postId}`);

            if (!content || !list) return;

            const submitBtn = /** @type {HTMLButtonElement} */ (btn);
            submitBtn.disabled = true;
            submitBtn.textContent = 'Posting...';

            const email = window['LikhaanCustomerEmail'] || '';
            let displayName = 'User';
            if (email) {
                const emailName = email.split('@')[0];
                if (emailName.length > 2) {
                    displayName = emailName[0] + '**' + emailName[emailName.length - 1];
                } else if (emailName.length === 2) {
                    displayName = emailName[0] + '**';
                } else {
                    displayName = emailName + '**';
                }
                displayName = displayName.charAt(0).toUpperCase() + displayName.slice(1);
            }

            const result = await apiRequest('add_comment', { postId, content, displayName });
            
            if (result && !result.errors && !result.userErrors?.length) {
                // Append locally
                const noCommentsMsg = list.querySelector('.likhaan-no-comments');
                if (noCommentsMsg) noCommentsMsg.remove();

                const newComment = document.createElement('div');
                newComment.className = 'likhaan-comment';
                const newCommentId = result.data?.metaobjectCreate?.metaobject?.id || '';
                newComment.innerHTML = `
                    <div class="likhaan-comment-header" style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 4px;">
                        <div class="likhaan-comment-author"><strong>${displayName}</strong>:</div>
                        <div class="likhaan-comment-actions" style="position: relative;">
                            <button type="button" class="likhaan-comment-options-btn" aria-label="Comment options" style="background: none; border: none; cursor: pointer; color: #888; padding: 0 4px;">
                                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
                            </button>
                            <div class="likhaan-comment-dropdown" style="display: none; position: absolute; right: 0; top: 100%; background: #fff; border: 1px solid #ddd; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); z-index: 10; min-width: 100px;">
                                <button type="button" class="likhaan-comment-delete-btn" data-comment-id="${newCommentId}" style="width: 100%; background: none; border: none; text-align: left; padding: 8px 12px; font-size: 13px; color: #e53e3e; cursor: pointer;">Delete</button>
                            </div>
                        </div>
                    </div>
                    <div class="likhaan-comment-content">${content.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</div>
                `;
                list.appendChild(newComment);
                input.value = '';
            } else {
                alert('Failed to post comment. Please try again.');
            }

            submitBtn.disabled = false;
            submitBtn.textContent = 'Post';
        });
    });

    /**
     * Helper function to show Toast
     * @param {string} postId
     * @param {string} message
     */
    function showToast(postId, message) {
        const toast = document.getElementById(`LikhaanToast-${postId}`);
        if (!toast) return;
        toast.textContent = message;
        toast.classList.add('show');
        setTimeout(() => {
            toast.classList.remove('show');
        }, 3000);
    }

    // --- Create Collection Logic ---
    const submitCreateBtns = document.querySelectorAll('.likhaan-submit-create-collection-btn');
    submitCreateBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const postId = btn.getAttribute('data-post-id');
            const input = /** @type {HTMLInputElement|null} */ (document.getElementById(`CreateCollectionInput-${postId}`));
            if (!input) return;
            const title = input.value.trim();
            const list = document.getElementById(`CollectionsList-${postId}`);

            if (!title || !list) return;
            
            const submitBtn = /** @type {HTMLButtonElement} */ (btn);
            const originalText = submitBtn.textContent;
            submitBtn.disabled = true;
            submitBtn.textContent = 'Creating...';

            const result = await apiRequest('create_collection', { title });
            
            if (result && result.data?.metaobjectCreate?.metaobject) {
                const newId = result.data.metaobjectCreate.metaobject.id;
                
                // Immediately save to the newly created collection
                const saveRes = await apiRequest('save_to_collection', { collectionId: newId, postId });
                
                // Remove loading text if it's there
                const loadingTxt = list.querySelector('.likhaan-collections-loading');
                if (loadingTxt) loadingTxt.remove();

                const newItem = document.createElement('div');
                newItem.className = 'likhaan-collection-item';
                newItem.setAttribute('data-id', newId);
                newItem.textContent = title;
                list.appendChild(newItem);
                input.value = '';
                
                // Close the create collection modal
                const modal = document.getElementById(`CreateCollectionModal-${postId}`);
                if (modal) modal.classList.remove('active');
                
                if (saveRes && saveRes.data && !saveRes.data.metaobjectUpdate.userErrors.length) {
                    showToast(postId, `Saved to '${title}'`);
                } else if (saveRes && saveRes.success) { // Fallback for simple success response
                    showToast(postId, `Saved to '${title}'`);
                }
            } else {
                alert('Failed to create collection.');
            }
            
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
        });
    });

    // Save to existing collection logic
    const saveDropdowns = document.querySelectorAll('.likhaan-save-dropdown');
    saveDropdowns.forEach(dropdown => {
        const list = dropdown.querySelector('.likhaan-collections-list');
        const postId = dropdown.id.replace('SaveDropdown-', '');
        
        list?.addEventListener('click', async (e) => {
            const target = /** @type {HTMLElement} */ (e.target);
            if (target && target.classList && target.classList.contains('likhaan-collection-item')) {
                const collectionId = target.getAttribute('data-id');
                
                const origText = target.textContent || '';
                target.textContent = 'Saving...';
                
                const saveRes = await apiRequest('save_to_collection', { collectionId, postId });
                
                if (saveRes && !saveRes.errors) {
                    target.textContent = 'Saved ✓';
                    showToast(postId, `Saved to '${origText.replace('Saving...','').trim()}'`);
                    setTimeout(() => {
                        target.textContent = origText;
                    }, 2000);
                } else {
                    target.textContent = 'Failed';
                }
            }
        });
    });

    // --- Report Logic ---
    const submitReportBtns = document.querySelectorAll('.likhaan-submit-report-btn');
    submitReportBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            const postId = btn.getAttribute('data-post-id');
            const form = btn.closest('.likhaan-report-form');
            if (!postId || !form) return;

            const categoryInput = /** @type {HTMLInputElement|null} */ (form.querySelector(`input[name="report_category_${postId}"]:checked`));
            const detailsInput = /** @type {HTMLTextAreaElement|null} */ (form.querySelector('.likhaan-report-input'));
            
            if (!categoryInput) {
                showToast(postId, "Please select a reason for reporting.");
                return;
            }

            const category = categoryInput.value;
            const details = detailsInput ? detailsInput.value.trim() : '';

            const submitBtn = /** @type {HTMLButtonElement} */ (btn);
            const originalText = submitBtn.textContent;
            submitBtn.disabled = true;
            submitBtn.textContent = 'Submitting...';

            const source = window.location.pathname.includes('likhaan-space') ? 'Space' : 'Social';

            const result = await apiRequest('report_post', { 
                post_id: postId,
                reporter_id: CUSTOMER_ID,
                category: category,
                details: details,
                source: source
            });
            
            if (result && !result.errors && !result.userErrors?.length && !result.error) {
                // Save to localStorage
                const storageKey = `likhaan_reported_posts_${CUSTOMER_ID}`;
                const reportedPosts = JSON.parse(localStorage.getItem(storageKey) || '[]');
                if (!reportedPosts.includes(postId)) {
                    reportedPosts.push(postId);
                    localStorage.setItem(storageKey, JSON.stringify(reportedPosts));
                }
                
                // Close modal
                const modal = document.getElementById(`ReportModal-${postId}`);
                if (modal) modal.classList.remove('active');
                
                showToast(postId, 'Report submitted successfully.');
                
                // Reset form
                if (detailsInput) detailsInput.value = '';
            } else if (result && result.error === "Already reported") {
                const modal = document.getElementById(`ReportModal-${postId}`);
                if (modal) modal.classList.remove('active');
                showToast(postId, "You have already reported this post.");
            } else {
                showToast(postId, 'Failed to submit report. Please try again.');
            }
            
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
        });
    });

    // --- Follow Logic ---
    const followBtn = document.getElementById('follow-creator-btn');
    if (followBtn) {
        const creatorId = followBtn.getAttribute('data-creator-id');
        const followText = document.getElementById('follow-creator-text');
        const followerCountEl = document.getElementById('creator-follower-count');

        // 1. Initial Status Check
        if (creatorId) {
            // Use direct fetch to bypass apiRequest's CUSTOMER_ID requirement (so guests can see live count)
            fetch('/apps/social', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'check_follow_status', followedId: creatorId, followerId: CUSTOMER_ID || null })
            })
            .then(res => res.json())
            .then(result => {
                if (result) {
                    if (result.isFollowing && CUSTOMER_ID) {
                        followText.textContent = 'Following';
                        followBtn.classList.add('following');
                    }
                    if (result.followerCount !== undefined && followerCountEl) {
                        followerCountEl.textContent = `${result.followerCount} Followers`;
                    }
                }
            })
            .catch(err => console.log('Live follower count fetch skipped/failed.', err));
        }

        // 2. Click Handler
        followBtn.addEventListener('click', async () => {
            if (!CUSTOMER_ID) {
                alert('Please log in to follow creators.');
                return;
            }
            if (!creatorId) {
                alert('Creator data is currently syncing. Please try again in a few moments.');
                return;
            }

            const isCurrentlyFollowing = followBtn.classList.contains('following');
            const originalText = followText.textContent;
            
            // Optimistic UI Update
            followText.textContent = isCurrentlyFollowing ? 'Follow' : 'Following';
            followBtn.classList.toggle('following', !isCurrentlyFollowing);
            
            let currentCount = parseInt(followerCountEl?.textContent?.replace(/[^0-9]/g, '') || '0', 10);
            if (followerCountEl) {
                const newCount = isCurrentlyFollowing ? Math.max(0, currentCount - 1) : currentCount + 1;
                followerCountEl.textContent = `${newCount} Followers`;
            }

            // Server Request
            const result = await apiRequest('follow_user', { followedId: creatorId, followerId: CUSTOMER_ID });
            
            if (result && result.success !== undefined) {
                // Confirm server state
                if (result.isFollowing) {
                    followText.textContent = 'Following';
                    followBtn.classList.add('following');
                } else {
                    followText.textContent = 'Follow';
                    followBtn.classList.remove('following');
                }
                if (followerCountEl && result.followerCount !== undefined) {
                    followerCountEl.textContent = `${result.followerCount} Followers`;
                }
            } else {
                // Revert UI on failure
                followText.textContent = originalText;
                followBtn.classList.toggle('following', isCurrentlyFollowing);
                if (followerCountEl) {
                    followerCountEl.textContent = `${currentCount} Followers`;
                }
            }
        });
    }

    // --- Global Click Delegation ---
    document.addEventListener('click', async (e) => {
        // Toggle comment dropdowns
        const optionsBtn = e.target.closest('.likhaan-comment-options-btn');
        if (optionsBtn) {
            e.stopPropagation();
            const dropdown = optionsBtn.nextElementSibling;
            const isVisible = dropdown.style.display === 'block';
            document.querySelectorAll('.likhaan-comment-dropdown').forEach(d => d.style.display = 'none');
            if (dropdown) dropdown.style.display = isVisible ? 'none' : 'block';
            return;
        } else {
            document.querySelectorAll('.likhaan-comment-dropdown').forEach(d => d.style.display = 'none');
        }

        // Handle comment deletion
        const deleteBtn = e.target.closest('.likhaan-comment-delete-btn');
        if (deleteBtn) {
            if (!confirm('Are you sure you want to delete this comment?')) return;
            
            const commentId = deleteBtn.getAttribute('data-comment-id');
            const commentDiv = deleteBtn.closest('.likhaan-comment');
            
            if (!commentId) {
                alert('Cannot delete this comment yet. Please refresh the page.');
                return;
            }

            deleteBtn.textContent = 'Deleting...';
            deleteBtn.disabled = true;

            const result = await apiRequest('delete_comment', { commentId, customerId: CUSTOMER_ID });
            
            if (result && result.success) {
                if (commentDiv) commentDiv.remove();
            } else {
                alert('Failed to delete comment.');
                deleteBtn.textContent = 'Delete';
                deleteBtn.disabled = false;
            }
        }
    });

}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLikhaanInteractions);
} else {
    initLikhaanInteractions();
}
